import { useMemo } from "react";
import type { OrderLine } from "../types";

interface PriceCalculationsResult {
  subtotal: number;
  vatAmount: number;
  totalAmount: number;
  commissionAmount: number;
}

export function usePriceCalculations(
  orderLines: OrderLine[],
  partnerId?: string,
  commissionType?: "fixed" | "percentage",
  commissionValue?: number
): PriceCalculationsResult {
  return useMemo(() => {
    const subtotal = orderLines.reduce((sum, line) => sum + line.line_total, 0);
    const vatAmount = orderLines.reduce((sum, line) => {
      const net = line.unit_price * line.quantity;
      return sum + (net * line.vat_rate / 100);
    }, 0);
    const totalAmount = subtotal + vatAmount;

    let commissionAmount = 0;
    if (partnerId && commissionType && commissionValue) {
      commissionAmount = commissionType === "percentage"
        ? totalAmount * (commissionValue / 100)
        : commissionValue;
    }

    return { subtotal, vatAmount, totalAmount, commissionAmount };
  }, [orderLines, partnerId, commissionType, commissionValue]);
}

export function calculateCommission(
  totalAmount: number,
  partnerId: string | undefined,
  commissionType: "fixed" | "percentage" | undefined,
  commissionValue: number | undefined
): number {
  if (!partnerId || !commissionType || !commissionValue) return 0;
  
  if (commissionType === "percentage") {
    return totalAmount * (commissionValue / 100);
  }
  return commissionValue;
}
